import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import classnames from "classnames";
import { Badge, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import AddMemberToGroupModal from "../../../../src/components/AddMemberToGroupModal";

// hooks
import { useRedux } from "../../../hooks/index";
import { useContacts } from "../../../hooks";
import { UserTypes, UserRoles } from "../../../api/auth";
import { getCurrentUserAction } from "../../../redux/profile2/p2_reducer";
import { fetchChatContactsRequest } from "../../../redux/chats/slice";

import * as urls from "../../../api/urls";

// actions
import {
  getChannelDetails,
  getChatUserDetails,
  getChatUserConversations2,
  changeSelectedChat,
  delUserFromGroup, getChatUserDetails2s, setActiveGroupId
} from "../../../redux/actions";

import { Utils } from "helpers/utils";
import { createSelector } from "reselect";
import UserAvatar from "components/UserAvatar";
import SearchWebUserModal from "components/SearchWebUserModal";
import { APIClient } from "api/apiCore";
import ChangeViewAs from "components/ChangeViewAs";
import UserProfileModal from "components/UserProfileModal";

interface GroupProps {
  member: any;
  onTotalModal: () => void;
  canModifyMember: boolean;
  onClickMemberName: (userId: number) => void;
}
const Member = ({ member, onTotalModal, canModifyMember, onClickMemberName }: GroupProps) => {

  // console.log('<Member>member:', member);
  // global store
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state) => ({
      profile2: state,
      curUserId: state.userId,
      curUserType: state.userType,
    })
  );
  const { profile2, curUserId, curUserType } = useAppSelector(storeData);
  const { categorizedContacts } = useContacts();
  const isYourSelf = profile2?.userId == member.id;
  //const isNoWebId = member?.userType == UserTypes.Customer && !member?.webUserId;
  const isNoWebId = (member?.userType == UserTypes.Customer || member?.userType == UserTypes.Supplier) && !member?.webUserId;
  const navigate = useNavigate();
  var fullName = member?.nameForShow;
  var shortName = "";
  if (member.firstName) {
    // fullName = `${member.firstName} ${member.lastName}`;
    shortName = `${member.firstName.charAt(0)}${member.lastName.charAt(0)}`;
  } else {

    const result = categorizedContacts.filter(
      categorizedContact => categorizedContact.data[0].id === member
    );

    if (result[0]) {

      // fullName = result[0].data[0].firstName + " " + result[0].data[0].lastName;
      shortName =
        result[0].data[0].firstName.charAt(0) +
        result[0].data[0].lastName.charAt(0);

    }
  }

  // const onSelectChat = (id: string | number, isChannel?: boolean) => {
  //   if (isChannel) {
  //     dispatch(getChannelDetails(id));
  //   } else {
  //     dispatch(getChatUserDetails(id));
  //   }
  //   dispatch(getChatUserConversations(id, null, null));
  //   console.log('Dashboard.UserProfileDetails.Member.selectedChat = ' + id);
  //   dispatch(changeSelectedChat(id));
  // };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  const onRemoveUser = (userId: number) => {
    if (Utils.IsViewAsAlert()) return;

    Utils.SweetConfirm('ยืนยันลบคนที่เลือกออกจากกลุ่ม')
      .then((result) => {
        if (result.isConfirmed) {
          dispatch(delUserFromGroup(member.groupId, userId));
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });

  }

  const isSaleOrCs = () => {
    const type = getUserTypeText();
    if (type == "Sale/CS" || type == "CS" || type == "Sale") {
      return true;
    }
    return false;
  }

  const getUserTypeText = () => {
    if (profile2.userType == UserTypes.Employee) {
      if (member?.userCompRole == "Sale/CS" || member?.userCompRole == "CS" || member?.userCompRole == "Sale") return member?.userCompRole;
      return Utils.GetUserTypeText(member?.userType);
    } else {
      return Utils.GetUserTypeText(member?.userType);
    }
  }

  const showViewAs = (profile2.userType == UserTypes.Employee && member?.userType == UserTypes.Customer);

  return (
    <li>
      {/* <Link to="#" onClick={() => onSelectChat(member.id)}> */}
      <Link to="#">
        <div className="d-flex align-items-center">

          {/* <div className="flex-shrink-0 avatar-xs me-2">
            {member.profileImage ? (
              <div
                className={classnames(
                  "chat-user-img",
                  "align-self-center",
                  "me-2",
                  "ms-0"
                )}
              >
                <img
                  src={member.profileImage}
                  className="rounded-circle avatar-xs"
                  alt=""
                />
              </div>
            ) : (
              <span
                className={classnames(
                  "avatar-title",
                  "rounded-circle",
                  "text-uppercase",
                  "text-white",
                  colors[color]
                )}
              >
                {shortName}
              </span>
            )}
          </div> */}

          <UserAvatar
            profileImage={member.profileImage}
            bgColor={member.bgColor}
            foreColor={member.foreColor}
            abbrName={member.abbrName}
          />

          <div className="flex-grow-1 overflow-hidden no-wrap">
            <p className="text-truncate mb-0">
              <span onClick={() => onClickMemberName(member?.id)} className="hand">{fullName}</span>
              {isYourSelf && (<span className="badge badge-soft-primary rounded p-1 ml-1 bg-secondary">you</span>)}

              {/* {member?.webUserType && (
                <span className="badge badge-soft-primary rounded p-1 ml-1 bg-secondary">
                  admin
                </span>
              )} */}
            </p>
            {/* {member?.webUserType && (
              <p className="text-truncate mb-0 fz-07" style={{ color: "gray", marginTop: "-5px" }}>
                <span className="" >
                  {member?.webUserType == 1 ? "ผู้ดูแลระบบ" : member?.webUserType == 2 ? "จัดซื้อ" : member?.webUserType == 3 ? "บัญชี" : ""}
                </span>
              </p>
            )} */}

            {curUserType == UserTypes.Employee && (
              <p className="text-truncate mb-0 fz-08" style={{ color: "gray", marginTop: "-5px" }}>
                🔐{Utils.GetLastOnlineText(member?.lastConnectDate)}
              </p>
            )}
          </div>

          {/* user role */}
          {/* <div className="ms-auto">
            <span className={"badge badge-soft-primary rounded p-1 ml-1 " + Utils.GetUserRoleBg(member?.userRole)}>{Utils.GetUserRoleText(member?.userRole)}</span>
          </div>

          &nbsp; */}


          <div className="ms-auto" style={{ display: showViewAs ? "" : "none" }}>
            <ChangeViewAs changeToId={member?.id} changeToName={member?.nameForShow}>
              <span className="mdi mdi-eye-outline fz-11" title="ดูมุมมองลูกค้า"></span>
            </ChangeViewAs>
            {/* <span className="mdi mdi-eye-outline fz-11" title="ดูมุมมองลูกค้า" onClick={onViewAsCustomerClick}></span> */}
          </div>

          {/* user type */}
          <div className="ms-auto">

            &nbsp;
            {/* {member?.webUserType && (
              <span className="badge badge-soft-primary">
AD
              </span>
            )} */}

            <span
              //onClick={() => canModifyMember && member?.userType === UserTypes.Customer && onTotalModal()}
              onClick={() => canModifyMember && (member?.userType === UserTypes.Customer || member?.userType === UserTypes.Supplier) && onTotalModal()}
              className={
                classnames("badge badge-soft-primary rounded p-1 ml-1 " + Utils.GetUserTypeBg(member?.userType), {
                  "cust-no-webuserid": isNoWebId,
                  "border-salecs": isSaleOrCs()
                })}>
              {/* {Utils.GetUserTypeText(member?.userType)} */}
              {getUserTypeText()}
            </span>
          </div>

          &nbsp;
          {(canModifyMember || isYourSelf) && (
            <div className="ms-auto">
              <span className="mdi mdi-close" style={{ color: "red" }} onClick={() => onRemoveUser(member.id)}></span>
            </div>
          )}

          {/* 

          {member.isAdmin && (
            <div className="ms-auto">
              <Badge className="badge badge-soft-primary rounded p-1">
                Admin
              </Badge>
            </div>
          )} */}
        </div>
      </Link>
    </li>
  );
};
interface GroupsProps {
  chatUserDetails: any;
}
const Members = ({ chatUserDetails }: GroupsProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (state) => ({
      profile2: state
    })
  );
  const { profile2 } = useAppSelector(storeData);

  const canModifyMember = profile2?.userType == UserTypes.Employee || (profile2?.userType == UserTypes.Employee && profile2?.isAdmin == true);

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isModalWebIdOpen, setIsModalWebIdOpen] = useState<boolean>(false);
  const [isModalFindWebUserOpen, setIsModalFindWebUserOpen] = useState<boolean>(false);
  const [isModalFindCustomerOpen, setIsModalFindCustomerOpen] = useState<boolean>(false);

  const onModalAddMemberClose = () => {
    setIsModalOpen((prev) => !prev);
  }
  const onToggleModal = async () => {
    setIsModalOpen((prev) => !prev);
  }

  const onModalWebIdClose = () => {
    setIsModalWebIdOpen((prev) => !prev);
  }

  const onToggleModalWebId = async () => {
    setIsModalWebIdOpen((prev) => !prev);
  }

  const [selectedMemberId, setSelectedMemberId] = useState(null);

  const onModalFindWebUserClose = (memberId: any) => {
    if (chatUserDetails.contactType == UserTypes.Group) {
      // console.log('chatUserDetails:', chatUserDetails);
      setIsModalFindWebUserOpen((prev) => {
        setSelectedMemberId(memberId);
        if (!prev && !chatUserDetails.companyId) {
          alert('ห้องแชทนี้ยังไม่ได้จับคู่กับบริษัทในระบบ dconnect');
          return false;
        } else {
          return !prev;
        }
      });
    } else if (chatUserDetails.contactType == UserTypes.GroupSupplier) {
      alert('ยังไม่รองรับ จับคู่กับ Supplier');
    }
  }

  const onToggleModalFindWebUser = async () => {
    setIsModalFindWebUserOpen((prev) => !prev);
  }

  const onModalFindCustomerClose = () => {
    setIsModalFindCustomerOpen((prev) => !prev);
  }

  const onModalFindCustomer = async () => {
    setIsModalFindCustomerOpen((prev) => !prev);
  }

  // console.log('chatUserDetails:', chatUserDetails);

  const [chkShowAllMember, setChkShowAllMember] = useState<boolean>(false);

  const members =
    chatUserDetails.members &&
    chatUserDetails.members.length &&
    chatUserDetails.members;
  // console.log('member of group:', members);

  const [userProfileModalOpen, setUserProfileModalOpen] = useState<boolean>(false);
  const [userProfileModalId, setUserProfileModalId] = useState<number>(-1);
  const userProfileModalToggle = () => { setUserProfileModalOpen(prev => !prev); }
  const onClickMemberName = (userId: number) => {
    try {
      setUserProfileModalId(userId);
      setUserProfileModalOpen(true);
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }
  return (
    <div>
      <AddMemberToGroupModal isOpen={isModalOpen} onClose={onModalAddMemberClose} groupId={chatUserDetails.id} groupType={chatUserDetails.contactType} />
      <SearchWebUserModal isOpen={isModalFindWebUserOpen} onClose={() => onModalFindWebUserClose(null)} groupId={chatUserDetails.id} selectedMemberId={selectedMemberId} />
      {/* <SearchCustomerModal  isOpen={isModalFindCustomerOpen} onClose={onModalFindCustomerClose} groupId={chatUserDetails.id} /> */}

      <div className="d-flex">
        <div className="flex-grow-1">
          <h5 className="font-size-11 text-muted text-uppercase room-group-title">
            สมาชิก
            {/* &nbsp;<input id="chkViewAll" type="checkbox" onChange={()=>setChkShowAllMember((prev) => !prev)}></input><label htmlFor="chkViewAll">แสดงหมด</label> */}
          </h5>

        </div>

        {canModifyMember && (
          <div className="ms-auto"><a className="font-size-12 d-block mb-2" href="#" onClick={onToggleModal}>เพิ่มสมาชิก</a></div>
        )}
      </div>

      {members ? (
        <ul className="list-unstyled chat-list mx-n4">
          {(members || []).map((member: any, key: number) => (
            <Member key={key} member={member} canModifyMember={canModifyMember} onClickMemberName={onClickMemberName} onTotalModal={() => onModalFindWebUserClose(member.id)} />
          ))}
        </ul>
      ) : (
        <p>No Members</p>
      )}
      <UserProfileModal isOpen={userProfileModalOpen} userId={userProfileModalId} onClose={userProfileModalToggle}></UserProfileModal>
    </div>

  );
};

export default Members;
